import { NavLink } from "react-router-dom";
import { useT } from "../i18n/LocaleProvider.js";

/**
 * Bottom tab bar with the raised center Recharge action — rides on every
 * authenticated screen so the #1 revenue action is unmissable.
 */
export function TabBar() {
  const t = useT();
  const cls = ({ isActive }: { isActive: boolean }) => (isActive ? "is-active" : "");
  return (
    <nav className="tabbar tabbar--center">
      <NavLink to="/home" className={cls}>
        <span className="t-ic" aria-hidden="true">💧</span>
        <span>{t.nav.home}</span>
      </NavLink>
      <NavLink to="/activity" className={cls}>
        <span className="t-ic" aria-hidden="true">☰</span>
        <span>{t.nav.activity}</span>
      </NavLink>
      <NavLink to="/recharge" className={({ isActive }) => `tab-center ${isActive ? "is-active" : ""}`}>
        <span className="tc-btn" aria-hidden="true">⚡</span>
        <span>{t.nav.recharge}</span>
      </NavLink>
      <NavLink to="/cards" className={cls}>
        <span className="t-ic" aria-hidden="true">💳</span>
        <span>{t.nav.cards}</span>
      </NavLink>
      <NavLink to="/profile" className={cls}>
        <span className="t-ic" aria-hidden="true">👤</span>
        <span>{t.nav.profile}</span>
      </NavLink>
    </nav>
  );
}
